import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { CoursesRequests } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${CoursesRequests.Pages.COURSES_REQUESTS}`,
    name: CoursesRequests.Pages.COURSES_REQUESTS,
    component: () => import(/* webpackChunkName: "courses-requests" */ './views/CoursesRequests.vue'),
    meta: {
      access_roles: RouteRoles[CoursesRequests.Pages.COURSES_REQUESTS],
    },
  },

  {
    path: `/${CoursesRequests.Pages.COURSES_REQUEST_NEW}`,
    name: CoursesRequests.Pages.COURSES_REQUEST_NEW,
    component: () => import(/* webpackChunkName: "courses-requests" */ './views/NewCoursesRequest.vue'),
    meta: {
      access_roles: RouteRoles[CoursesRequests.Pages.COURSES_REQUEST_NEW],
    },
  },

  {
    path: `/${CoursesRequests.Pages.COURSES_REQUEST_DETAIL}/:id/edit`,
    name: CoursesRequests.Pages.COURSES_REQUEST_EDIT,
    component: () => import(/* webpackChunkName: "courses-requests" */ './views/EditCoursesRequest.vue'),
    meta: {
      access_roles: RouteRoles[CoursesRequests.Pages.COURSES_REQUEST_EDIT],
    },
  },

  {
    path: `/${CoursesRequests.Pages.COURSES_REQUEST_DETAIL}/:id`,
    name: CoursesRequests.Pages.COURSES_REQUEST_DETAIL,
    component: () => import(/* webpackChunkName: "courses-requests" */ './views/DetailCoursesRequest.vue'),
    meta: {
      access_roles: RouteRoles[CoursesRequests.Pages.COURSES_REQUEST_DETAIL],
    },
  },
];

export default routes;
